import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
  ViewEncapsulation,
  forwardRef,
} from '@angular/core';
import {
  ControlValueAccessor,
  FormGroup,
  FormsModule,
  NG_VALUE_ACCESSOR,
  ReactiveFormsModule,
} from '@angular/forms';
import { InputTextModule } from 'primeng/inputtext';
import { Skeleton, SkeletonModule } from 'primeng/skeleton';

@Component({
  selector: 'ls-input-atom',
  standalone: true,
  imports: [
    InputTextModule,
    ReactiveFormsModule,
    CommonModule,
    SkeletonModule,
    FormsModule,
  ],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => InputAtomComponent),
      multi: true,
    },
  ],
  templateUrl: './input-atom.component.html',
  styleUrl: './input-atom.component.scss',
  host: {
    class: 'ls-element',
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class InputAtomComponent
  implements OnChanges, OnInit, ControlValueAccessor
{
  private _inputType = 'text';
  @Input()
  get inputType(): string | undefined {
    return this._inputType;
  }
  set inputType(value: string | undefined) {
    this._inputType = value || 'text';
  }
  @Input() min?: string;
  @Input() max?: string;
  @Input() placeholder?: string;
  @Input() inputClass?: string;
  @Input() inputId?: string;
  @Input() disabled = false;
  @Input() loading = false;
  @Input() textError?: string;
  @Input() position: 'left' | 'right' = 'left';
  @Input() icon = 'pi-search';
  @Input() showIcon = false;
  @ViewChild('input') input!: Input;
  @ViewChild('skeleton') skeleton!: Skeleton;

  @Output() onInput = new EventEmitter<Event>();

  value = '';
  positionClass!: string;
  onChange = (_: any) => {};
  onTouch = () => {};

  ngOnInit(): void {}

  constructor(public cd: ChangeDetectorRef) {}

  writeValue(value: any): void {
    this.value = value;
    if (value !== null) {
      this.cd.markForCheck();
    }
  }
  registerOnChange(fn: any): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: any): void {
    this.onTouch = fn;
  }
  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
    this.cd.markForCheck();
  }

  handleInput(event: Event) {
    this.value = (event.target as HTMLInputElement).value;
    this.cd.markForCheck();
    this.onTouch();
    this.onChange(this.value);
    this.onInput.emit(event);
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.positionClass =
      this.position === 'left' ? 'p-input-icon-left' : 'p-input-icon-right';
  }
}
